import { Component, OnInit, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ModalService } from 'src/app/shared/services/modal.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'update-affiliated-user',
  templateUrl: './update-affiliated-user.component.html',
  styleUrls: ['./update-affiliated-user.component.scss']
})
export class UpdateAffiliatedUserComponent implements OnInit {
  public loading: boolean = false;
  public userUrl = environment.runtime.userManagementApiUrl;

  constructor(
    private modal: ModalService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  selected: string = "";
  ngOnInit() {
  }

  public close(data = null) {
    this.modal.close(data);
  }
}
